import React from 'react';
import './fragment_name_change_styles.scss';
import axios from 'axios';
import { createApiServerRoute } from "../../../models/network/api_client";
import { connect } from 'react-redux';
import { actionSetCurrentClients } from "../../../models/redux/reducers/activity_main_reducers/clients_reducer/action_clients";
import Table from "../../../components/table_component/table/table";
import TableHeader from "../../../components/table_component/table_header/table_header";
import TableBody from "../../../components/table_component/table_body/table_body";
import TableIndexColumn from "../../../components/table_component/table_index_column/table_index_column";
import TableTextualColumn from "../../../components/table_component/table_textual_column/table_textual_column";
import TableContainerColumn from "../../../components/table_component/table_container_column/table_container_column";
import TableHeading from "../../../components/table_component/table_heading/table_heading";
import UrlArgsBundle from "../../../core/url_args_bundle";
import {ACTIVITY_TAG, API_KEY, FRAGMENT_TAG} from "../../../utils/constants";
import {withRouter} from "react-router-dom";
import IosSwitchMaterialUi from 'ios-switch-material-ui';
import { Button } from '@mui/material'; // Optional if you use MUI

// Define the number of users to display per page
const USERS_PER_PAGE = 20;

// ... [imports remain the same]

class NameChangeFragment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: "",
            nameChangeRequests: [],
            currentPage: 1,
            totalPageCount: 0,
        };
    }

    componentDidMount() {
        this.getNameChangeRequestsByPage(1, this.state.filter);
    }

    getNameChangeRequestsByPage = (pageNo, searchText) => {
        const params = new URLSearchParams();
        params.append("__api_key__", API_KEY);
        params.append("searchtext", searchText);
        params.append("page", pageNo);

        axios.post(createApiServerRoute('fetch-name-change-requests.php'), params, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        }).then(res => {
            if (res.data.state === 'SUCCESS') {
                const responseData = res.data.data;
                const requests = responseData.requests;

                // Sort pending ones first
                requests.sort((a, b) => {
                    return a.status === "0" && b.status !== "0" ? -1 : 1;
                });

                this.setState({
                    nameChangeRequests: requests,
                    currentPage: responseData.currentPage,
                    totalPageCount: responseData.totalPages,
                });
            } else {
                console.error("Fetch Failed", res);
            }
        });
    };

    acceptNameChange = (requestId) => {
        const formData = new FormData();
        formData.append("__api_key__", API_KEY);
        formData.append("id", requestId); // Make sure this matches your backend expectations
    
        axios.post(createApiServerRoute('update-name-request-status.php'), formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            if (res.data.state === 'SUCCESS') {
                // ✅ Refetch data after successful update
                this.getNameChangeRequestsByPage(this.state.currentPage, this.state.filter);
            } else {
                console.error("Accept failed:", res.data.message);
            }
        }).catch(err => {
            console.error("API error:", err);
        });
    };
    
    rejectNameChange = (requestId) => {
        const params = new URLSearchParams();
        params.append("__api_key__", API_KEY);
        params.append("request_id", requestId);
    
        axios.post(createApiServerRoute('reject-name-change.php'), params, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        }).then(res => {
            if (res.data.state === 'SUCCESS') {
                // ✅ Refetch data after successful rejection
                this.getNameChangeRequestsByPage(this.state.currentPage, this.state.filter);
            } else {
                console.error("Reject failed:", res.data.message);
            }
        }).catch(err => {
            console.error("API error:", err);
        });
    };
    

    render() {
        const { filter, nameChangeRequests, currentPage, totalPageCount } = this.state;

        const filteredRequests = nameChangeRequests.filter(request =>
            request.current_username.toLowerCase().includes(filter.toLowerCase()) ||
            request.requested_name.toLowerCase().includes(filter.toLowerCase())
        );

        const startIndex = (currentPage - 1) * USERS_PER_PAGE;
        const requestsToDisplay = filteredRequests.slice(startIndex, startIndex + USERS_PER_PAGE);

        return (
            <div className="flex flex-col">
                <div className="flex items-center mb-4 ml-4">
                    <input
                        type="text"
                        value={filter}
                        onChange={(e) => this.setState({ filter: e.target.value })}
                        className="mx-2 px-4 py-2 rounded-2xl border-2 border-blue outline-none placeholder-indigo-600 placeholder-opacity-50 custom-search-input"
                        placeholder="Enter current or requested name"
                    />
                    <button
                        className="ml-2 px-5 py-2 rounded-3xl bg-blue-500 text-white hover:bg-blue-600"
                        onClick={() => this.getNameChangeRequestsByPage(1, filter)}
                    >
                        Search
                    </button>
                    <button
                        className="ml-2 px-5 py-2 rounded-3xl bg-red-500 text-white hover:bg-red-600"
                        onClick={() => {
                            this.setState({ filter: "" });
                            this.getNameChangeRequestsByPage(1, "");
                        }}
                    >
                        Reset
                    </button>
                </div>

                <Table>
                    <TableHeader>
                        <TableHeading>#</TableHeading>
                        <TableHeading>Current Name</TableHeading>
                        <TableHeading>Requested Name</TableHeading>
                        <TableHeading>Status</TableHeading>
                        <TableHeading>Created At</TableHeading>
                        <TableHeading>Actions</TableHeading>
                    </TableHeader>

                    <TableBody>
                    {requestsToDisplay.map((request, index) => (
    <tr key={request.id}>
        <TableIndexColumn num={startIndex + index + 1} />
        <TableTextualColumn text={request.current_username} />
        <TableTextualColumn text={request.requested_name} />
        <TableTextualColumn text={request.status.charAt(0).toUpperCase() + request.status.slice(1)} />
        <TableTextualColumn text={request.created_at} />
        <TableContainerColumn>
            {request.status === "0" && (
                <>
                    <button
                        className="bg-green-500 hover:bg-green-600 text-white font-semibold py-1 px-4 rounded-2xl shadow-md transition duration-300 mr-2"
                        onClick={() => this.acceptNameChange(request.id)}
                    >
                        Accept
                    </button>
                    {/* Uncomment below to add a reject button if needed */}
                    {/* <button
                        className="bg-red-500 hover:bg-red-600 text-white font-semibold py-1 px-4 rounded-2xl shadow-md transition duration-300"
                        onClick={() => this.rejectNameChange(request.id)}
                    >
                        Reject
                    </button> */}
                </>
            )}

            {request.status === "1" && (
                <span className="text-green-600 font-semibold">Accepted</span>
            )}
        </TableContainerColumn>
    </tr>
))}

                    </TableBody>
                </Table>

                <div className="pagination-container">
                    <button
                        className={`pagination-button${currentPage === 1 ? ' disabled' : ''}`}
                        onClick={() => {
                            const newPage = Math.max(currentPage - 1, 1);
                            this.setState({ currentPage: newPage });
                            this.getNameChangeRequestsByPage(newPage, filter);
                        }}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <span className="current-page">
                        Page {currentPage} / {totalPageCount}
                    </span>
                    <button
                        className={`pagination-button${currentPage >= totalPageCount ? ' disabled' : ''}`}
                        onClick={() => {
                            const newPage = Math.min(currentPage + 1, totalPageCount);
                            this.setState({ currentPage: newPage });
                            this.getNameChangeRequestsByPage(newPage, filter);
                        }}
                        disabled={currentPage >= totalPageCount}
                    >
                        Next
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = rootReducer => ({
    clients: rootReducer.clients.currentClients
});

const mapDispatchToProps = dispatch => ({
    actionSetCurrentClients: clients => dispatch(actionSetCurrentClients(clients))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NameChangeFragment));
